import React from "react";
import './Price.css'
const Price = ()=>{
    return(
        <section className="section-price wrapper">
            <div className="price-elemenet">
                <table>
                    <thead>
                        <tr>
                            <th colSpan="2">Przejście jednej trasy przez 1 osobę:</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>do 18 roku życia</td>
                        <td>15 zł</td>
                    </tr>
                    <tr>
                        <td>dorośli powyżej 18 lat</td>
                        <td>25 zł</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="price-elemenet">
                <table>
                    <thead>
                    <tr>
                        <th colSpan="2">Przejście dwóch tras przez 1 osobę:</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>do 18 roku życia</td>
                        <td>25 zł</td>
                    </tr>
                    <tr>
                        <td>dorośli powyżej 18 lat</td>
                        <td>35 zł</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="price-elemenet">
                <table>
                <thead>
                    <tr>
                        <th colSpan="2">Przejście trzech tras przez 1 osobę:</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>do 18 roku życia</td>
                        <td>35 zł</td>
                    </tr>
                    <tr>
                        <td>dorośli powyżej 18 lat</td>
                        <td>45 zł</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="price-elemenet">
                <table>
                <thead>
                    <tr>
                        <th colSpan="2">Grupy liczące co najmniej 20 osób <br/> 1 trasa/1 osoba:</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>do 18 roku życia</td>
                        <td>13 zł</td>
                    </tr>
                    <tr>
                        <td>dorośli powyżej 18 lat</td>
                        <td>22 zł</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </section>
    )
}

export default Price;